import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Main from 'pages/Main';
import Login from 'pages/Login';
import Unauthorized from 'pages/Unauthorized';
import Callback from 'pages/Callback';
import Navigate from 'pages/Navigate';
import { IsLoginProvider } from './auth/IsLoginContext'

function App() {
  return (
    <BrowserRouter>
      <IsLoginProvider>
        <Routes>
          <Route path={'/'} element={<></>} />
          <Route path={'/navigate'} element={<Navigate />} />
          <Route path={'/finance'} element={<Main />} />
          <Route path={'/bizops'} element={<Main />} />
          <Route path={'/login'} element={<Login />} />
          <Route path={'/callback'} element={<Callback />} />
          <Route path={'/unauthorized'} element={<Unauthorized />} />
        </Routes>
      </IsLoginProvider>
    </BrowserRouter>
  );
}

export default App;